import React, { Component } from 'react';
import { View } from '@dbk/ui-react-utils';

import { createContainer } from '@dbk-legacy/muster/react';
import Router from '@dbk-legacy/muster/react-router';
import cx from 'classnames';

import Portal from './portal';
import { getRoutes } from './app.routes';

import config from '../../data/get-settings';
import delay from '../../utils/delay';
import { VASCO_RASP_ERR_URL, ROUTES, LOGGEDIN} from "../../constants";
import AdminPortal from './admin-portal';
import RMPortal from './rm-portal';
import AppIdlePopup from '../../../@extension/CH/src/components/common/app-idle/app-idle-popup'
import ui from '../../data/ui.json'
import { ConsoleView } from 'react-device-detect';

// Do we really need it ?
const element = document.getElementById('loggedInUserEmail');
const isInternalElement = document.getElementById('isInternal');
const isWebssoInternal =
  isInternalElement != null ? isInternalElement.value : null;

const isRMAccessElement = document.getElementById('isRM');
const isRMAccessEnabled =
  isRMAccessElement != null ? isRMAccessElement.value : null;

// const isRMAccessEnabled = isRMAccessElement != null ? isRMAccessElement.value : null;

// != null tests agains null and undefined. if u want to test only agains one !`==`;
// const objNotNullOrUndefined = (obj) => obj != null;
// const objsNotNullOrUndefined = (...args) => args.every(objNotNullOrUndefined);

// const idConnect = () => objsNotNullOrUndefined(jwt, user, ret);

class App extends Component {

  constructor(props){
    super(props);

    this.resetTimer = this.resetTimer.bind(this);

    this.state = {
      time : setTimeout(()=>{}, ui.inactive.activeTimeoutSeconds),
      modalVisible: false, 
      activetimeout:ui.inactive.activeTimeoutSeconds,
      logoutdebug:false
      }  
      this.wrapperRef = React.createRef();      
     }

    logout = () => {
        this.props.setLogoutPopup(true);
      this.props.inactive.startCountdownTimer();
    }

    logoutScreen = () => {
      document.removeEventListener('mousedown',this.resetTimer);
      document.removeEventListener('keypress',this.resetTimer);
      document.removeEventListener('scroll',this.resetTimer);
    }
    
    loggingOut = () => {
      const { inactive, logout, rmLogout} = this.props;
      const data = {
        inactiveCountdwon: this.props.inactive.countdown,
        calledReason: "Logging out from inactivity popUp"
      }

      if(this.props.rmAccess.rmAuthorised){
        rmLogout();
      }else{
        logout(data);
      }
      this.logoutScreen();
      setTimeout(() => { inactive.stopCountdownTimer(); }, 5000);    
    }

  resetTimer = async (e) => {
    if(e.target &&  e.target.parentElement && e.target.parentElement.id === 'no_button_logout_popup')
    {
         this.props.inactive.stopTimerAtZero();
         this.loggingOut()
    }
    if(e.target && e.target.parentElement && e.target.parentElement.id === 'yes_button_logout_popup')
    {
          this.props.setLogoutPopup(false);
          await this.props.inactive.setPopupVisibility(false);
    }
    if(this.props.logoutPopup.isVisible)
    {
       return;
    }

    this.props.setLogoutPopup(false);

    clearTimeout(window.logoutTime);
    this.props.inactive.stopCountdownTimer();
    window.logoutTime = setTimeout(this.logout,this.state.activetimeout)
    }

   autoLogout =() => {
      this.props.inactive.stopTimerAtZero();
       this.loggingOut();
   }

  registerEvents = () => {
    document.addEventListener("mousedown", this.resetTimer.bind(this), true);
    document.addEventListener("keypress", this.resetTimer.bind(this), true);
    document.addEventListener("scroll", this.resetTimer.bind(this), true);
  }

   componentWillReceiveProps(nextProps){
   
     if(this.props.app.config.logoutdebug !== nextProps.app.config.logoutdebug && nextProps.app.config.logoutdebug){
     
      let timeout = nextProps.app.config.logoutdebug ? nextProps.app.config.activetimeout : ui.inactive.activeTimeoutSeconds;
      this.setState({activetimeout : timeout});
    }
    
    if(this.props.vascoauthentication.vascoAuthorised !== nextProps.vascoauthentication.vascoAuthorised && nextProps.vascoauthentication.vascoAuthorised){
       
      this.registerEvents();
      window.logoutTime = setTimeout(this.logout,this.state.activetimeout)
    }
     
   }

   
  async componentDidMount() {
    const {
      auth: { authorised },
      changePage,
      marque: { loginDissmiss },
      languages: { getlanguages },
    } = this.props;

    this.props.getconfig();

    this.props.initWindow();
    // get lang and langCode from localStorage,
    // if there is not, set default to English
    getlanguages()

    // if (idConnect()) {
    //   changePage('/idconnect');
    //   return;
    // }
  
    const currentURL = this.props.ui.history.currentLocation.pathname;
    const authBypass = config.authbypass.filter((bypassUrl) => !authorised && currentURL.indexOf(`${bypassUrl}`) >= 0).length > 0;

    if (!authBypass) {
      if (isRMAccessEnabled) {
        changePage('/rmAccess');
        return;
      }
    }

    if (isWebssoInternal && !isRMAccessEnabled) {
      changePage('/webssoconnect');
      return;
    }

    if (!authBypass) {
      // await delay(300);       // WMCE-37572  allows User to Access the web screens without Login
      if (!isWebssoInternal) {
        changePage('/login')
      }
    }
  }

  render() {
  
    const routesConfig = getRoutes(this.props);
    const hasMarqueAdmin = this.props.auth.isAdminUser;
    const currentURL = this.props.ui.history.currentLocation.pathname;

    const isVasco = currentURL.indexOf(VASCO_RASP_ERR_URL) < 0;
    const { i18n , ais } = this.props;

    const isDocuploadFlow = currentURL.includes(ROUTES.RMACCESS.DOC_UPLOAD_ROUTE);

    if (isDocuploadFlow && isRMAccessEnabled) {
      return (
        <RMPortal {...this.props} i18n={i18n}>
          <Router webfolder={config.webfolder} config={routesConfig} />
        </RMPortal>
      )
    }

    return (
      <View ref={this.wrapperRef}>
        {hasMarqueAdmin ?
          <AdminPortal {...this.props} isVasco={isVasco} isWebsso={isWebssoInternal} i18n={i18n}>
            <Router webfolder={config.webfolder} config={routesConfig} />
          </AdminPortal>
          :
          <Portal {...this.props} isVasco={isVasco} i18n={i18n} resetTimer={this.resetTimer} ais={ ais }>
            <Router webfolder={config.webfolder} config={routesConfig} />
          </Portal>
        }
        {this.props.logoutPopup.isVisible && <AppIdlePopup resetTime=
        {this.resetTimer} logoutFunction={this.loggingOut} logoutAtZero={this.autoLogout}/>}
      </View>
    );
  }
}

export default createContainer({
  $queries: {
    logout: { $call: 'auth.logout' },
    rmLogout: { $call : 'rmAccess.logout'},
    rmAccess:{
      rmAuthorised: true
    },
    changePage: { $call: 'ui.history.push' },
    initWindow: { $call: 'screen.update' },
    screen: {
      isSmall: true,
    },
    getconfig: { $call: 'app.getConfig' },
    auth: {
      authorised: true,
      entitlement: true,
      dashboardAuthorised: true,
      passwordExpired: true,
      isNonActivePortfolio: true,
      vascoFlow: true,
      isAdminUser: true,
      entitlementProcessed: true,
      langCode: true,
      isRMUserGroup: true,
      cryptoEncryptedObj: true,
      authSuccess:true,
    },
    rmAccess: {
      rmAuthorised: true
    },
    config: {
      regionCode: true,
      docsign: true,
      chat: true,
    },
    marque: {
      loginDissmiss: true,
    },
    app: {
      global: {
        deviceInfo: {
          isTablet: true,
        },
      },
      config:{
        activetimeout:true,
        logoutdebug:true,
      }
    },
    languages: {
      getlanguages: { $call: 'getlanguages' },
    },
    ui: {
      history: {
        currentLocation: { pathname: true, route: true }
      }
    },
    docsign: {
      showDocsignBanner: true,
      docsignBannerSeen: true
    },
    rsa: {
      onChangePage: { $call: 'changePage' },
      rsaAuthorised: true
    },
    vascoauthentication: {
      vascoAuthorised: true,
    },
    chat: {
      showWelcomeScreen: true,
      showChat: true,
      closeWS: true,
      isChatSelected: true,
    },
    handleChatNavigation: {
      $call: 'chat.handleNavigation'
    },
    i18n: {
      locale: true,
      messages: true
    },
    vascoauthentication: {
      vascoAuthorised: true,
    },
    inactive: {
      countdown: true,
      startCountdownTimer: { $call: 'startCountdownTimer' },
      stopCountdownTimer: { $call: 'stopCountdownTimer' },
      stopTimerAtZero: { $call: 'stopTimerAtZero' },
      setPopupVisibility: { $call : 'setPopupVisibility' },
      autoLogoutEvent: true,
      setPopupVisibility: { $call : 'setPopupVisibility' },
      timeout: true
    },
    setDatePickerClose: {
      $set: 'reports.closeDatePicker'
    },
        reports:{
      closeDatePicker:true
    },
    logoutPopup: {
      isVisible: true
    },
    ais: {
      isBannerVisible: true
    },
    setLogoutPopup: { $set: 'logoutPopup.isVisible' },
  }}
)(App);
